module.exports = __webpack_public_path__ + "media/customizations/delwebbfulshear/logo-new-d52fcac668f2507aa6b297388a88b4a1.png";